import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent {

  constructor() {
  }

  scrollToTop(){
    window.scroll(0,0);
  }
}
